'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _showPasswordElement = require('./showPasswordElement.html');

var _showPasswordElement2 = _interopRequireDefault(_showPasswordElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var showPassword = {
  bindings: {
    model: '='
  },
  template: _showPasswordElement2.default
};

exports.default = showPassword;


/** WEBPACK FOOTER **
 ** ./src/app/directives/common/showPassword.js
 **/